import type { LinkedAccount } from "@store/linkedAccountSlice";
import { AccountActionsMenu } from "./AccountActionsMenu";
import { AccountStatusBadge } from "./AccountStatusBadge";
import { ReconnectButton } from "./ReconnectButton";
import { ThemeAwareClassName } from "@components/ThemeAwareClassName";
import { normalizeNameWithAt } from "@utils/util";

const ACCOUNT_TYPE_LABELS: Record<string, string> = {
  TIKTOK_SHOP_OFFICIAL_ACCOUNT: "Office Account",
  TIKTOK_MARKETING_ACCOUNT: "Marketing Account",
  TIKTOK_SHOP_CREATOR: "Creator Account",
};

interface LinkedAccountRowProps {
  account: LinkedAccount;
}

export const LinkedAccountRow = ({ account }: LinkedAccountRowProps) => {
  const expired = account.expired === true;
  const accountTypeLabel = account.accountType ? (ACCOUNT_TYPE_LABELS[account.accountType] ?? account.accountType) : "";

  return (
    <div className="group flex items-start gap-[40px]">
      <div className="flex items-center gap-[16px]">
        <div className="flex size-[48px] shrink-0 items-center justify-center overflow-hidden rounded-full bg-kds-bg-overlay">
          {account.accountImage ? (
            <img
              src={account.accountImage}
              alt={account.accountName ?? ""}
              className="size-full object-cover"
              loading="lazy"
            />
          ) : null}
        </div>
        <div className="flex min-w-0 flex-col gap-[4px]">
          <div className="flex items-center gap-[4px]">
            <p className="max-w-[160px] truncate text-[16px] font-normal leading-[24px] text-kds-fg">
              {normalizeNameWithAt(account.accountName)}
            </p>
            <AccountStatusBadge expired={expired} />
            {expired && <ReconnectButton />}
          </div>
          {accountTypeLabel ? (
            <ThemeAwareClassName
              as="p"
              className="text-[14px] font-normal leading-[22px]"
              lightClassName="text-[#00000050]"
              darkClassName="text-[#FFFFFF50]"
            >
              {accountTypeLabel}
            </ThemeAwareClassName>
          ) : null}
        </div>
      </div>
      <AccountActionsMenu account={account} />
    </div>
  );
};
